const {required} = require("@common/react/cs-form/validators/required");

exports.downloadReportFormConfig = {
    fields: {
        title: {
            transforms: ["trim"],
            validators: [required],
            debounce: true,
        },
        "style.downloadFormats": {
            validators: [required],
        },
    },
};
